<lib-gojs-schematic
  [substationId]="selectedSubstation?.id ?? null"
  [substationName]="selectedSubstation?.name ?? null"
  [showSchemaAssetPicker]="true"
>
  <app-schema-asset-picker
    schematicHeaderLeft
    [templates]="templates"
    [substations]="substations"
    [selectedTemplate]="selectedTemplate"
    [selectedSubstation]="selectedSubstation"
    (templateSelected)="selectTemplate($event)"
    (substationSelected)="selectSubstation($event)"
    (searchChange)="onSearchChange($event)"
  ></app-schema-asset-picker>
</lib-gojs-schematic>

<div *ngIf="!loading && !selectedSubstation" class="schema-empty">
  {{ !templates.length ? 'No substation templates found.' : !selectedTemplate ? 'Select a template.' : substations.length ? 'Select a substation.' : 'No substations found for this template.' }}
</div>
